import React, { useState } from 'react';
import AuthLayout from '../components/auth/AuthLayout';
import LoginForm from '../components/auth/LoginForm';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail } = FiIcons;

export default function AuthPage() {
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState('');

  const handleLogin = (val) => {
    setEmail(val);
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <AuthLayout title="Check your email" subtitle={`We've sent a magic link to ${email}`}>
        <div className="text-center py-8">
          <div className="w-20 h-20 bg-primary/10 text-primary rounded-[2rem] flex items-center justify-center mx-auto mb-8">
            <SafeIcon icon={FiMail} className="w-10 h-10" />
          </div>
          <p className="text-slate-400 font-medium mb-8 leading-relaxed">
            Click the link in the email to instantly sign in. If you don't see it, check your spam.
          </p>
          <button 
            onClick={() => setSubmitted(false)}
            className="text-[10px] font-black text-slate-500 uppercase tracking-widest hover:text-white transition-colors"
          >
            Entered the wrong email?
          </button>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Get your page" subtitle="Claim your username and start documenting your effort.">
      <LoginForm onLogin={handleLogin} />
    </AuthLayout>
  );
}